import AppBg from '../app-bg'
import AppScrollColor from '../app-scroll-color'
import AppBook from '../app-book'
import AppPageLinks from '../app-page-links'
import MixinResize from '../mixin-resize'
import MixinScroll from '../mixin-scroll'
import { getProduct } from '../../content.js'
import easeScrollTo from '../utils/easeScrollTo'
import AppParallax from '../app-parallax'
import { getPosition, getBounds } from '../utils/position'

export default
{
    mixins: [
        MixinResize,
        MixinScroll
    ],

    components: {
        AppBg,
        AppScrollColor,
        AppBook,
        AppPageLinks,
        AppParallax
    },

    data()
    {
        return {
            products: [
                getProduct('cocoa'),
                getProduct('cacao')
            ],

            scrollColorMin: [],
            scrollColorMax: [],
            scrollColorColors: [],

            currentScrollArea: null,
            areaEls: [],

            isProductIn: false
        }
    },

    mounted()
    {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: [0.5]
        }

        this.stateObserver = new IntersectionObserver(this.onStateObserve, options)
        this.stateObserver.observe(this.$refs.resume)
        this.$refs.product.forEach(el => this.stateObserver.observe(el))
        // this.stateObserver.observe(this.$refs.end)

        this.areaEls = [
            this.$refs.resume,
            ...this.$refs.productContainer,
            this.$refs.endContainer.$el
        ]
        this.areaObserver = new IntersectionObserver(this.onAreaObserve, options)
        this.areaEls.forEach(el => this.areaObserver.observe(el))

        this.$nextTick(() =>
        {
            this.onResized()
            this.onScroll(this.scroll.realY)
        })

        const imgs = [...this.$el.querySelectorAll('img')]
        imgs.forEach(img =>
        {
            if (!img.complete)
            {
                let onLoaded
                onLoaded = () =>
                {
                    this.onResized()
                    img.removeEventListener('load', onLoaded)
                }
                img.addEventListener('load', onLoaded)
            }
        })
    },

    destroyed()
    {
        this.stateObserver.disconnect()
        this.areaObserver.disconnect()
    },

    methods:
    {
        scrollNext()
        {
            const i = this.areaEls.indexOf(this.currentScrollArea)
            if (i > -1)
            {
                const y = this.areaEls[i + 1].offsetTop
                easeScrollTo(y)
            }
        },

        onScroll(y)
        {
            const onProduct = (y - this.scrollColorMin[0]) / (this.scrollColorMax[this.scrollColorMax.length - 1] - this.scrollColorMin[0])
            this.isProductIn = onProduct > 0 && onProduct < 1
        },

        onStateObserve(entries)
        {
            entries.forEach(entry =>
            {
                const index = this.$refs.product.indexOf(entry.target) + 1
                if (entry.intersectionRatio > 0.5)
                {
                    if (index > 0)
                    {
                        this.eventHub.$emit('product:select', index)
                    }
                    else if (entry.target === this.$refs.resume)
                    {
                        this.eventHub.$emit('product:select', 0)
                    }
                    else if (entry.target === this.$refs.end)
                    {
                        this.eventHub.$emit('product:select', this.$refs.product.length + 1)
                    }
                }
                else if (entry.intersectionRatio < 0.5)
                {
                    if (index === this.$refs.product.length && entry.intersectionRect.top <= 0)
                    {
                        this.eventHub.$emit('product:select', this.$refs.product.length + 1)
                    }
                }
            })
        },

        onAreaObserve(entries)
        {
            entries.forEach(entry =>
            {
                if (entry.intersectionRatio > 0.5)
                {
                    this.currentScrollArea = entry.target
                }
            })
        },

        onResized()
        {
            const min = []
            const max = []
            this.$refs.productContainer.forEach(el =>
            {
                const y = el.offsetTop
                min.push(y - this.resize.height / 2)
                max.push(y - this.resize.height / 2)
            })

            max.shift()
            max.push(max[max.length - 1] + this.$refs.productContainer[this.$refs.productContainer.length - 1].offsetHeight)

            this.scrollColorColors = this.products.map(({ color }) => color)
            this.scrollColorMin = min
            this.scrollColorMax = max
        },

        scrollTo(refName)
        {
            const y = getPosition(this.$refs[refName])[1] - getBounds(document.body.querySelector('.fixed-header')).height
            easeScrollTo(y)
        }
    }
}